export default __webpack_public_path__ + "static/coninsa-green-0b670bb68cd1902f8a559d327acb0744.svg";